import Swal from "sweetalert2";

export const showAlertDialog = ({
  title,
  msg,
  confirmButtonText,
  onConfirm,
}) => {
  Swal.fire({
    title: title,
    text: msg,
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: confirmButtonText,
  }).then((result) => {
    if (result.isConfirmed) {
      onConfirm();
    }
  });
};

export const showSuccessDialog = ({ title, msg, allowOutsideClick = true }) => {
  Swal.fire({
    title: title,
    text: msg,
    icon: "success",
    allowOutsideClick: allowOutsideClick,
    allowEscapeKey: allowOutsideClick,
    allowEnterKey: allowOutsideClick,
  });
};

export const showFailedDialog = ({ title, msg }) => {
  Swal.fire({
    title: title,
    text: msg,
    icon: "error",
  });
};

export const showLoadingDialog = () => {
  Swal.fire({
    title: 'Loading...',
    allowEscapeKey: false,
    allowOutsideClick: false,
    showConfirmButton: false,
    didOpen: () => {
      Swal.showLoading();
    }
  })
};

export const hideLoadingDialog = () => {
  Swal.close()
};